(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  let blocks = document.querySelectorAll('.mega-menu__list_custom__blocks');
  blocks.forEach(block => {
      if(block.querySelectorAll(`:scope ${'li'}`).length <= 0){
          block.parentNode.classList.add('withoutBlocks');
      }
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.topbar = document.querySelector('#header__topbar');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsSearchToggle = this.header.getAttribute('data-search-style') === 'toggle';
      this.headerBounds = {};
      this.setHeaderHeight(); 

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search') || this.querySelector('.search-modal__content');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      if (this.topbar) {
         document.documentElement.style.setProperty('--topbar-height', `${this.topbar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler); 
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop === 0) this.classList.remove('header-wrapper--transparent'); 
        
      if (this.headerIsAlwaysSticky) this.classList.remove('header-wrapper--transparent'); 
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
         this.header.classList.add('scrolled-past-header');
         this.classList.remove('header-wrapper--transparent'); 
        if (this.preventHide) return;
         requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
           this.header.classList.add('scrolled-past-header');
         
        if (!this.preventReveal) {
           requestAnimationFrame(this.reveal.bind(this)); 
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
         this.header.classList.remove('scrolled-past-header');
         this.classList.add('header-wrapper--transparent');
         requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      if (this.headerIsSearchToggle) this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zmz-announcement-bar"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      var adCookie = document.getElementById('announcement-bar__coupon');
      if (adCookie) {
        var viewPeriod = parseInt(adCookie.getAttribute('[data-ad-period]')); 
        var adCookieClick = adCookie.querySelector('[data-ad-cookie]');
        adCookie.style.display = 'block';

        if (getCookie('cookieAd') == 'closed') {
            adCookie.style.display = 'none';  
        }
                      
        adCookieClick.addEventListener('click', function(e) {
          e.preventDefault(); 
          adCookie.style.display = 'none';
          setCookie('cookieAd', 'closed', viewPeriod, '/');
        });    
      }   
    }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zmz-lookbook-picker"] && !Shopify.designMode) return;
  try {
     

if (!customElements.get('slider-component-lookbook')) {
  customElements.define(
    'slider-component-lookbook',
    class SliderComponentLookbook extends SliderComponent {
    constructor() {
      super();
      this.sliderControlLinksArray = Array.from(this.parentElement.parentElement.parentElement.querySelectorAll('[data-bullet]'));
      if(!this.sliderControlLinksArray.length) return;  
      this.enableSliderLooping = true;

      this.sliderFirstItemNode = this.slider.querySelector('.slider__slide'); 
      if (this.sliderItemsToShow.length > 0) {
        this.currentPage = 1;
      }


      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
    }

    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

      if (!isFirstSlide && !isLastSlide) return;
      
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = this.slider.scrollLeft - this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      }

      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }

    update() {
      super.update();
      this.sliderControlLinksArray = Array.from(this.parentElement.parentElement.parentElement.querySelectorAll('[data-bullet]'));
      this.prevButton.removeAttribute('disabled'); 

      if (!this.sliderControlLinksArray.length) {
        return; 
      }

      this.sliderControlLinksArray.forEach(link => {
        link.removeAttribute('data-bullet-active');
        link.removeAttribute('aria-current');
      });

      const activeLink = this.sliderControlLinksArray[this.currentPage - 1];
      activeLink.setAttribute('data-bullet-active', '');
      activeLink.setAttribute('aria-current', true);
    }

    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const linkElements = Array.from(this.parentElement.parentElement.parentElement.querySelectorAll('[data-bullet]')); 

        const isCurrentSlide = index === this.currentPage - 1; 

        linkElements.forEach(button => {
          button.setAttribute('tabindex', isCurrentSlide ? '-1' : '');
        });

        item.setAttribute('aria-hidden', !isCurrentSlide);
        item.setAttribute('tabindex', isCurrentSlide ? '' : '-1');
      });
    }

    linkToSlide(event) {
      event.preventDefault(); 
      const clickedLinkIndex = this.sliderControlLinksArray.indexOf(event.currentTarget);
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (clickedLinkIndex + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
 );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zmz-lookbook-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lookbook-component')) {
customElements.define(
'lookbook-component',
class LookbookComponent extends HTMLElement {
constructor() {
super();
this.popoverButtons = this.querySelectorAll('[data-popover-bullet]');
this.popperInstances = new Map();

this.popoverButtons.forEach((button) =>
button.addEventListener('click', () => {
const popoverID = button.getAttribute('data-popover');
if (this.popperInstances.has(popoverID)) {
this.hidePopper(popoverID);
} else {
this.hideAllPopovers();
this.showPopper(popoverID);
}
})
);

this.slider = this.querySelector('[id^="Slider-"]');
this.slider.addEventListener('scroll', () => this.hideAllPopovers());

document.addEventListener('click', (event) => {
const target = event.target;
const isButton = Array.from(this.popoverButtons).some((button) => button.contains(target));
const isPopover = Array.from(this.popperInstances.values()).some((popper) =>
popper.state.elements.popper.contains(target)
);

if (!isButton && !isPopover) {
this.hideAllPopovers();
}
});
}

connectedCallback() {
const handleIntersection = (entries) => {
entries.forEach((entry) => {
if (!entry.isIntersecting) {
this.hideAllPopovers();
}
});
};
const observer = new IntersectionObserver(handleIntersection.bind(this));
observer.observe(this);
}

createInstance(popoverID) {
const popperPopup = this.querySelector(`#popover-id-${popoverID}`);
const popperButton = this.querySelector(`#button-id-${popoverID}`);

if (popperPopup && popperButton) {
const popperInstance = Popper.createPopper(popperButton, popperPopup, {
placement: 'auto',
modifiers: [
{
name: 'offset',
options: {
offset: [0, 6],
},
},
{
name: 'flip',
options: {
allowedAutoPlacements: ['left', 'right', 'top', 'bottom'],
rootBoundary: 'viewport',
},
},
],
});
this.popperInstances.set(popoverID, popperInstance); // Store the popper instance in the map
}
}

destroyInstance(popoverID) {
if (this.popperInstances.has(popoverID)) {
const popperInstance = this.popperInstances.get(popoverID);
popperInstance.destroy();
this.popperInstances.delete(popoverID); // Remove the popper instance from the map
}
}

showPopper(popoverID) {
const popperPopup = this.querySelector(`#popover-id-${popoverID}`);
const popperButton = this.querySelector(`#button-id-${popoverID}`);

if (popperPopup && popperButton) {
popperPopup.setAttribute('is-open', '');
popperButton.setAttribute('is-active', '');
this.createInstance(popoverID);
}
}

hidePopper(popoverID) {
const popperPopup = this.querySelector(`#popover-id-${popoverID}`);
const popperButton = this.querySelector(`#button-id-${popoverID}`);

if (popperPopup && popperButton) {
popperPopup.removeAttribute('is-open');
popperButton.removeAttribute('is-active');
this.destroyInstance(popoverID);
}
}
hideAllPopovers() {
this.popoverButtons.forEach((button) => {
const popoverID = button.getAttribute('data-popover');
this.hidePopper(popoverID);
});
}
}
);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zmz-ticker"] && !Shopify.designMode) return;
  try {
    

  class TickerElement extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const tickerList = this.querySelector('.ticker__inner');
		const tickerDirect = parseInt(this.dataset.direction);
		const tickerListWidth = tickerList.offsetWidth;
		const cloneEl = tickerList.cloneNode(true);
		cloneEl.classList.add('cloned');
		this.append(cloneEl);

		let start = window.performance.now();
		let progress;
		let translateX;
		let duration = 21000;
		let mouseEntered = false;

		const handleMouseEnter = () => {
		mouseEntered = true;
		};

		const handleMouseLeave = () => {
		mouseEntered = false;
		};

		this.parentElement.addEventListener('mouseenter', handleMouseEnter);
		this.parentElement.addEventListener('mouseleave', handleMouseLeave);

		const tick = (now) => {
		if (mouseEntered === false) {
			progress = (now - start) / duration;

			if (progress > 1) {
			progress %= -1;
			start = now;
			}

			if (tickerDirect == 1) {
			translateX = tickerListWidth * progress - tickerListWidth;
			cloneEl.style.transform = `translate3d(${translateX}px, 0 , 0)`;
			tickerList.style.transform = `translate3d(${translateX}px, 0 , 0)`;
			} else {
			translateX = tickerListWidth * progress;
			tickerList.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
			cloneEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
			}
		}

		window.requestAnimationFrame(tick);
		};

		tick(window.performance.now());
	}
  }

  customElements.define('ticker-element', TickerElement);


  } catch(e) { console.error(e); }
})();
})();
